export enum EntityPlacementCtaTypeEnum {
  ApplyNow = 'APPLY_NOW',
  ApplyNowButton = 'APPLY_NOW_BUTTON',
  Prequal = 'PREQUAL',
  ReadReview = 'READ_REVIEW',
  ProductImage = 'PRODUCT_IMAGE',
  ProductName = 'PRODUCT_NAME',
  RestOfProductCard = 'REST_OF_PRODUCT_CARD',
}
